import React, { useEffect } from 'react';
import { useSettings } from '../../context/SettingsContext';
import './DonationsPage.css';

const DonationsPage = () => {
  const { t } = useSettings();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="donations-page">
      <div className="donations-container">
        <div className="donations-hero">
          <div className="hero-icon">🤝</div>
          <h1 className="donations-title">{t('donationsTitle')}</h1>
          <p className="donations-subtitle">
            {t('donationsSubtitle')}
          </p>
        </div>

        <div className="development-notice">
          <div className="notice-icon">⚙️</div>
          <h2>{t('devNoticeTitle')}</h2>
          <p className="notice-text">
            {t('devNoticeText')}
          </p>
        </div>

        <div className="mission-section">
          <h2>{t('missionTitle')}</h2>
          <p>
            {t('missionText')}
          </p>
        </div>

        <div className="features-section">
          <h2>{t('whatWillBeTitle')}</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <h3>{t('featVerified')}</h3>
              <p>{t('featVerifiedDesc')}</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <h3>{t('featTransparent')}</h3>
              <p>{t('featTransparentDesc')}</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <h3>{t('featSafe')}</h3>
              <p>{t('featSafeDesc')}</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <h3>{t('featReports')}</h3>
              <p>{t('featReportsDesc')}</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <h3>{t('featControl')}</h3>
              <p>{t('featControlDesc')}</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <h3>{t('featSupport')}</h3>
              <p>{t('featSupportDesc')}</p>
            </div>
          </div>
        </div>

        <div className="who-we-help">
          <h2>{t('whoWeHelpTitle')}</h2>
          <div className="help-categories">
            <div className="help-category">
              <span className="category-icon">🏥</span>
              <h3>{t('catSick')}</h3>
              <p>{t('catSickDesc')}</p>
            </div>

            <div className="help-category">
              <span className="category-icon">👴</span>
              <h3>{t('catElderly')}</h3>
              <p>{t('catElderlyDesc')}</p>
            </div>

            <div className="help-category">
              <span className="category-icon">👨‍👩‍👧</span>
              <h3>{t('catFamily')}</h3>
              <p>{t('catFamilyDesc')}</p>
            </div>

            <div className="help-category">
              <span className="category-icon">🦽</span>
              <h3>{t('catDisabled')}</h3>
              <p>{t('catDisabledDesc')}</p>
            </div>
          </div>
        </div>

        <div className="trust-section">
          <h2>{t('trustTitle')}</h2>
          <div className="trust-points">
            <div className="trust-point">
              <span className="trust-number">01</span>
              <div className="trust-content">
                <h3>{t('trustPersonal')}</h3>
                <p>{t('trustPersonal')}</p> {/* Reusing key or should have desc? Using title as prompt was insufficient, assuming title implies content for trust points as they are short */}
              </div>
            </div>

            <div className="trust-point">
              <span className="trust-number">02</span>
              <div className="trust-content">
                <h3>{t('trustDocs')}</h3>
                <p>{t('trustDocs')}</p>
              </div>
            </div>

            <div className="trust-point">
              <span className="trust-number">03</span>
              <div className="trust-content">
                <h3>{t('trustDirect')}</h3>
                <p>{t('trustDirect')}</p>
              </div>
            </div>

            <div className="trust-point">
              <span className="trust-number">04</span>
              <div className="trust-content">
                <h3>{t('trustPublic')}</h3>
                <p>{t('trustPublic')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <div className="cta-content">
            <h2>{t('notifyTitle')}</h2>
            <p>
              {t('notifyText')}
            </p>
            <div className="cta-form">
              <input 
                type="email" 
                placeholder="Email" 
                className="email-input"
              />
              <button className="notify-button">{t('notifyButton')}</button>
            </div>
            <p className="cta-note">
              {t('orWriteUs')} <a href="mailto:donate@kyrgyzaid.kg">donate@kyrgyzaid.kg</a>
            </p>
          </div>
        </div>

        <div className="contact-info">
          <p>
            {t('contactQuestions')}
          </p>
          <p className="contact-email">
            📧 <a href="mailto:donate@kyrgyzaid.kg">donate@kyrgyzaid.kg</a>
          </p>
          <p className="contact-phone">
            📞 +996 (xxx) xx-xx-xx
          </p>
        </div>
      </div>
    </div>
  );
};

export default DonationsPage;
